import { render, staticRenderFns } from "./vc-badge.vue?vue&type=template&id=cd176d68&scoped=true&"
import script from "./vc-badge.vue?vue&type=script&lang=js&"
export * from "./vc-badge.vue?vue&type=script&lang=js&"
import style0 from "./vc-badge.vue?vue&type=style&index=0&id=cd176d68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd176d68",
  null
  
)

export default component.exports